var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"no-close-on-backdrop":"","centered":"","hide-footer":"","title":_vm.bonus.id ? 'Edit bonus' : 'New bonus',"modal-class":_vm.theme}},[_c('BonusEdit',{attrs:{"bonus":_vm.bonus,"error":_vm.errorMsg,"loading":_vm.loading},on:{"request-save":_vm.onRequestSave,"close":_vm.hide}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }